import CollectionsContainer from './components/CollectionsContainer';
import * as t from './actionTypes';
import * as actions from './actions';
import * as sagas from './sagas';
import * as selectors from './selectors';

export { default as catalogCollectionsReducer } from './reducer';
export { t, actions, sagas, selectors };

export default CollectionsContainer;
